import { LeaderboardEntry } from "@/services/leaderboard/get-leaderboard";
import { CountryFlag } from "@/components/ui/country-flag/country-flag";

interface LeaderboardRowProps {
  entry: LeaderboardEntry;
  isCurrentUser?: boolean;
  onClick?: () => void;
}

/**
 * Individual leaderboard entry row component
 * Displays rank, username, and score
 */
export const LeaderboardRow = ({
  entry,
  isCurrentUser = false,
  onClick,
}: LeaderboardRowProps) => {
  return (
    <div
      onClick={onClick}
      className={`flex items-center gap-1 p-1 transition cursor-pointer ${
        isCurrentUser
          ? "bg-pk-gold-4/40 border-l-4 border-pk-gold-4"
          : "bg-pk-gray-1/40 hover:bg-pk-gray-1/60"
      }`}
    >
      {/* Rank */}
      <div
        className={`min-w-[30px] text-left font-bold text-base xs:text-lg ${
          isCurrentUser ? "text-pk-gold-4" : "text-pk-gray-4"
        }`}
      >
        #{entry.rank}
      </div>

      {/* Country Flag */}
      <CountryFlag countryCode={entry.country} size="sm" className="mr-1" />

      {/* Username */}
      <div
        className={`flex-1 text-left text-xs xs:text-base font-medium truncate ${
          isCurrentUser ? "text-pk-gold-4" : "text-pk-gray-5"
        }`}
      >
        {entry.username}
      </div>

      {/* Score */}
      <div className="flex items-center gap-2">
        <img
          src="/assets/icons/medal.png"
          width={20}
          height={20}
          alt="Score"
          className={isCurrentUser ? "" : "grayscale opacity-70"}
        />
        <span
          className={`min-w-[60px] text-right font-bold text-base xs:text-lg ${
            isCurrentUser ? "text-pk-gold-4" : "text-pk-gray-4"
          }`}
        >
          {entry.score}
        </span>
      </div>
    </div>
  );
};
